'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FOCUS_GROUP = exports.FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = exports.FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = exports.FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = exports.FOCUS_AUTO = 'data-autofocus-inside';


//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/cjs/constants.js
// module id = 114
// module chunks = 0